import find from 'lodash/find';
import { deletePGAItems } from '../api/deleteFormData';
import { savePGAItemField } from '../api/setFormData';
import {
  getAMS_OR2_LOTNUMBER_Values,
  getAMS_OR2_LPCOTRANSACTION_Values,
  getAPHAVS_COMMODITY,
  getAPHAVS_COMMODITY_COMPONENT,
  getAPHAVS_COMMODITY_PRODUCT,
  getAPHAVS_NAMEANDCODE,
  getAPHAVS_NAMEANDCODE_COMPONENT,
  getAPHAVS_NAMEANDCODE_PRODUCT,
  getAPHAVS_SOURCE_TYPE,
  getAPHAVS_SOURCE_TYPE_COMPONENT,
  getAPHAVS_SOURCE_TYPE_PRODUCT,
  getATFATF_LICENSE_Values,
  getAdvanced_Containers,
  getCOLA_COLA_Values,
  getCPSC_CITATION_ITL_Values,
  getCPSC_CITATION_LAB_Values,
  getCPSC_CITATION_NOL_Values,
  getCPSC_ENTITY_ITL_Values,
  getCPSC_ENTITY_LAB_Values,
  getCPSC_PRODUCT_IDENTIFIER_Values,
  getCPSC_TEST_REPORT_ITL_Values,
  getCPSC_TEST_REPORT_LAB_Values,
  getCOMO_Values,
  getConformanceDoc_Values,
  getDEADEA_constituent_Values,
  getEPA_VNE_PRODUCTCOMPONENT_Values,
  getFDADRU_CONSTITUENT_ELEMENT, getFDADRU_LOTNUMSTUFF,
  getFDAFOO_AOC,
  getFDAFOO_PQ,
  getFDAFOO_SOURCE_TYPE,
  getFSI_FSI_LOT_LLL_Values,
  getLACEY_ACT_REPEATED_Values,
  getLPCO_Values,
  getORRemarks_Values,
  getPSX_REPEATED_INGREDIENT_Values,
  getRepeatedArrivalLocation_Values,
  getSIMPLE_LPCO_VALUES,
  getVehicleVin_Values,
  getVehicle_Values,
  get_REPEATED_NMF_370_BOX5_Values,
  get_REPEATED_NMF_370_HARVEST_Values,
  get_REPEATED_NMF_HMS_DOCUMENT_Values,
  get_REPEATED_NMF_HMS_HARVEST_Values,
  get_REPEATED_OMC_AQF_Values,
  get_REPEATED_PARTIES_PGA_Values
} from '../formSections/util/initialValues';
import { CPSC_REPEATED_LISTS } from '../formSections/pga/CPSC_CPS/util';
import { renumberLaceyActContainers, renumberPGAItems } from '../util';

const initialState = {
  // initialValues
  loading: true
}

export const listMapper = {
  FDAFOO_AOC_List: getFDAFOO_AOC,
  FDAFOO_SOURCE_TYPE_List: getFDAFOO_SOURCE_TYPE,

  APHAVS_NAMEANDCODE_Values : getAPHAVS_NAMEANDCODE,
  APHAVS_COMMODITY_Values : getAPHAVS_COMMODITY,
  APHAVS_SOURCE_TYPE_Values : getAPHAVS_SOURCE_TYPE,
  APHAVS_NAMEANDCODE_COMPONENT_Values : getAPHAVS_NAMEANDCODE_COMPONENT,
  APHAVS_COMMODITY_COMPONENT_Values : getAPHAVS_COMMODITY_COMPONENT,
  APHAVS_SOURCE_TYPE_COMPONENT_Values : getAPHAVS_SOURCE_TYPE_COMPONENT,
  REPEATED_PARTIES_PGA_Values : get_REPEATED_PARTIES_PGA_Values,
  REPEATED_OMC_AQF_Values : get_REPEATED_OMC_AQF_Values,
  ATFATF_LICENSE_Values : getATFATF_LICENSE_Values,
  PSX_REPEATED_INGREDIENT_Values: getPSX_REPEATED_INGREDIENT_Values,
  APHAVS_NAMEANDCODE_PRODUCT_Values : getAPHAVS_NAMEANDCODE_PRODUCT,
  APHAVS_COMMODITY_PRODUCT_Values : getAPHAVS_COMMODITY_PRODUCT,
  APHAVS_SOURCE_TYPE_PRODUCT_Values : getAPHAVS_SOURCE_TYPE_PRODUCT,
  REPEATED_NMF_370_HARVEST_Values: get_REPEATED_NMF_370_HARVEST_Values,
  REPEATED_NMF_370_BOX5_Values: get_REPEATED_NMF_370_BOX5_Values,
  REPEATED_NMF_HMS_HARVEST_Values: get_REPEATED_NMF_HMS_HARVEST_Values,
  REPEATED_NMF_HMS_DOCUMENT_Values: get_REPEATED_NMF_HMS_DOCUMENT_Values,

  FDAFOO_PQ_List: getFDAFOO_PQ,
  FDADRU_CONSTITUENT_ELEMENT_Values: getFDADRU_CONSTITUENT_ELEMENT,
  EPA_VNE_PRODUCTCOMPONENT_Values: getEPA_VNE_PRODUCTCOMPONENT_Values,
  FSI_FSI_LOT_LLL_Values: getFSI_FSI_LOT_LLL_Values,
  FDADRU_LOTNUM_Values: getFDADRU_LOTNUMSTUFF,
  DEADEA_constituent_Values: getDEADEA_constituent_Values,
  RepeatedArrivalLocation_Values: getRepeatedArrivalLocation_Values,
  AMS_OR2_LOTNUMBER: getAMS_OR2_LOTNUMBER_Values,
  AMS_OR2_LPCOTRANSACTION:getAMS_OR2_LPCOTRANSACTION_Values,
  LACEY_ACT_REPEATED: getLACEY_ACT_REPEATED_Values,
  APHAVS_COMO_Values: getCOMO_Values,
  APHAVS_LPCO_Values: getLPCO_Values,
  SIMPLE_LPCO_VALUES: getSIMPLE_LPCO_VALUES,
  ORRemarks_Values: getORRemarks_Values,
  CONTAINERS_ADVANCED: getAdvanced_Containers,
  COLA_COLA_Values: getCOLA_COLA_Values,
  VEHICLE_INFO_Values: getVehicle_Values,
  VEHICLE_VIN_Values: getVehicleVin_Values,
  CONFORMANCE_DOC_Values: getConformanceDoc_Values,
  [CPSC_REPEATED_LISTS.ENTITY_ITL]: getCPSC_ENTITY_ITL_Values,
  [CPSC_REPEATED_LISTS.ENTITY_LAB]: getCPSC_ENTITY_LAB_Values,
  [CPSC_REPEATED_LISTS.PRODUCT_IDENTIFIER]: getCPSC_PRODUCT_IDENTIFIER_Values,
  [CPSC_REPEATED_LISTS.CITATION_ITL]: getCPSC_CITATION_ITL_Values,
  [CPSC_REPEATED_LISTS.CITATION_LAB]: getCPSC_CITATION_LAB_Values,
  [CPSC_REPEATED_LISTS.CITATION_NOL]: getCPSC_CITATION_NOL_Values,
  [CPSC_REPEATED_LISTS.TEST_REPORT_ITL]: getCPSC_TEST_REPORT_ITL_Values,
  [CPSC_REPEATED_LISTS.TEST_REPORT_LAB]: getCPSC_TEST_REPORT_LAB_Values,
}

export default function PGAReducerWithMerchandiseId(targetPGA, totallyUniquePGAId) {
  return function FDAFOOReducer(state = initialState, action) {
    if(state.pgaGuid && state.pgaGuid != (action.pgaGuid || totallyUniquePGAId)){
      return state;
    }
    let pgaGuid = action.pgaGuid;
    switch (action.type) {
      case `INITIALIZE_VALUES_TARGET_PGA_${totallyUniquePGAId}`: {
        if(action?.payload?.loading){
          return Object.assign({}, {}, { loading: true, pgaGuid: action.pgaGuid }, {pgaTemplates : []})
        }

        return Object.assign({}, state, { ...action.payload }, { 
          loading: false, pgaGuid: action.pgaGuid,
          pgaType: action.targetPGA,
         }, {pgaTemplates : action.templates})
      }
      case `UPDATE_${targetPGA}_FIELD_${totallyUniquePGAId}`: {//UPDATE_PGA_FIELD
        if(action.payload?.deletePgaField){
          return Object.assign({}, state, { [action.field]: null })
        }
        let newItem = Object.assign({}, state[action.field])
        newItem.value = action.payload || ""
        return Object.assign({}, state, { [action.field]: newItem })
      }
      case `COPY_${targetPGA}_FIELD_${totallyUniquePGAId}`: {
          savePGAItemField(pgaGuid, action.pgaItems,action.merchandiseId,targetPGA,{isPgaCopy:true})
          return Object.assign({}, {
            pgaTemplates:state.pgaTemplates,loading: state.loading, merchandiseId: state.merchandiseId
          }, { ...action.payload }, { loading: false }/*, {pgaTemplates : null}*/)
      }
      case `SAVE_${targetPGA}_FIELD_${totallyUniquePGAId}`: {//SAVE_PGA_FIELD!!!!!!!!!!!!!!!
        if(Array.isArray(action.field)){
          let arrayToSave = [];
          for(let kkey of Object.keys(state)){
            if(action.field.includes(kkey)){
              arrayToSave.push(state[kkey]);
            }
          }
          savePGAItemField(pgaGuid, 
            arrayToSave,
            action.merchandiseId,
            targetPGA
          )
        } else {
          savePGAItemField(pgaGuid, 
            [state[action.field]],
            action.merchandiseId,
            targetPGA
          )
        }
        return state
      }
      case `ADD_REPEATED_SUB_ITEM_${targetPGA}_${totallyUniquePGAId}`: {
        function getAllexistingindexes(boxforcurrentcardinality){
          let seen = [];
          for(var iii = 0; iii < boxforcurrentcardinality.length;iii++){
            if(boxforcurrentcardinality[iii]){
              let firstkey =find(boxforcurrentcardinality[iii],a=>a.key).key;
              seen[parseInt(firstkey.split(".")[2])-1]=true;
            }
          }
          return seen;
        }
        let cardinality = action.containerCardinality;
        let listname = action.list;
        let newindex = 0;
        if(state[listname]  && state[listname][cardinality]){
          let seen = getAllexistingindexes(state[listname][cardinality]);
          for(;newindex<seen.length;newindex++){
            if(!seen[newindex])break;
          }
        }
        let itemsToSave = []
        let newItems = (state[listname] && state[listname][cardinality])?state[listname][cardinality].slice():[];
        if(action.initialValues_th.length){
          for(let oneItemToAdd of action.initialValues_th){
            let items = listMapper[listname](newindex)
            for(let itemkey of Object.keys(items)){
              items[itemkey].key = items[itemkey].key.split(".")[0]+"."+(cardinality+1)+"."+(newindex+1);
              
            }
  
            // Combine both loops - iterate once, update values and collect items
            Object.keys(items).forEach(itemKey => {
              if(oneItemToAdd[itemKey]){
                items[itemKey].value = oneItemToAdd[itemKey].value.value;
              }
              itemsToSave.push(items[itemKey]);
            });
            newItems.push(items)
            newindex++;
          }
           
        } else {
          let items = listMapper[listname](newindex)
          for(let itemkey of Object.keys(items)){
            items[itemkey].key = items[itemkey].key.split(".")[0]+"."+(cardinality+1)+"."+(newindex+1);
            
          }

          // Combine both loops - iterate once, update values and collect items
          Object.keys(items).forEach(itemKey => {
            if(action.initialValues_th[itemKey]){
              items[itemKey].value = action.initialValues_th[itemKey].value.value;
            }
            itemsToSave.push(items[itemKey]);
          });
          newItems.push(items)
        }
        savePGAItemField(pgaGuid, itemsToSave, action.merchandiseId, targetPGA)
        // Shallow copy the array - only the modified cardinality needs to be new
        let listToSave = state[listname] ? [...state[listname]] : [];
        listToSave[cardinality] = newItems;
        return Object.assign({}, state, {[listname] : listToSave})

      
      }
      case `REPEATED_ITEM_REPLACE_ALL_${targetPGA}_${totallyUniquePGAId}`: {
        let itemsToSave = [];
        for(let item of action.newItemsToReplace){
          for(let onekey of Object.keys(item)){
            itemsToSave.push(item[onekey]);
          }
        }
        savePGAItemField(pgaGuid, itemsToSave, action.merchandiseId, targetPGA)
        return Object.assign({}, state, { [action.list]: action.newItemsToReplace })
      }
      case `ADD_REPEATED_ITEM_ARRAY_${targetPGA}_${totallyUniquePGAId}`: {
        state[action.list] = state[action.list] || {}
        let items = listMapper[action.list](state[action.list].length + 1)
        debugger;
        if(action.arrayOfNewItemsToAdd){
          items=action.arrayOfNewItemsToAdd;
        }
        let itemsToSave = []
        for (let itemKey in items) {
          itemsToSave.push(items[itemKey])
        }
        savePGAItemField(pgaGuid, itemsToSave, action.merchandiseId, targetPGA)
        let newItems = state[action.list].slice()
        newItems.push(items)
        
        return Object.assign({}, state, { [action.list]: newItems })
      }
      case `ADD_REPEATED_ITEM_${targetPGA}_${totallyUniquePGAId}`: {
        state[action.list] = state[action.list] || {}
        let items = listMapper[action.list](state[action.list].length + 1)
        if(action.newItemsToAdd){
          items=action.newItemsToAdd;
        }
        let itemsToSave = []
        for (let itemKey in items) {
          itemsToSave.push(items[itemKey])
        }
        savePGAItemField(pgaGuid, itemsToSave, action.merchandiseId, targetPGA)
        let newItems = state[action.list].slice()
        newItems.push(items)
        
        return Object.assign({}, state, { [action.list]: newItems })
      }
      case `ADD_REPEATED_SECTION_${targetPGA}_${totallyUniquePGAId}`: {
        // Can only add last section, not intermediate sections
        // Sections can contain repeated groups and repeated sub groups
        let items, itemsToSave = [], finalState = {}, newItems
        Object.assign(finalState, state)
        action.sectionConfig.forEach(section => {
          state[section.listName] = state[section.listName] || {}
          items = listMapper[section.listName](state[section.listName].length + 1)
          if(section.level === 2){
            Object.keys(items).forEach(itemKey => {
              items[itemKey].key = items[itemKey].key + ".1"
            })
          }
          itemsToSave = itemsToSave.concat(Object.values(items))
          newItems = state[section.listName].slice()
          if(section.level === 1){
            newItems.push(items)
          }
          else if(section.level === 2){
            newItems.push([items])
          }
          Object.assign(finalState, finalState, {[section.listName]: newItems})
        })
        savePGAItemField(pgaGuid, itemsToSave, action.merchandiseId, targetPGA)
        return finalState
      }
      case `UPDATE_REPEATED_SUB_FIELD_${targetPGA}_${totallyUniquePGAId}`: {
        let list = state[action.list].slice()
        let cardinality = action.containerCardinality;;
        if(!list[cardinality][action.index])return state;
        list[cardinality][action.index][action.field] = list[cardinality][action.index][action.field] || {};
        list[cardinality][action.index][action.field].value = action.payload
        
        return Object.assign({}, state, { [action.list]: list })
      }
      case `UPDATE_REPEATED_FIELD_${targetPGA}_${totallyUniquePGAId}`: {
        if(!state[action.list])return state;
        let list = state[action.list].slice()
        list[action.index][action.field].value = action.payload
        
        return Object.assign({}, state, { [action.list]: list })
        
      }
      case `SAVE_REPEATED_SUB_FIELD_${targetPGA}_${totallyUniquePGAId}`: {
        if(!state[action.list])return state;
        if(Array.isArray(action.field)){
          savePGAItemField(pgaGuid, 
            action.field,
            action.merchandiseId,
            targetPGA
          )
          return state;
        
        }
        savePGAItemField(pgaGuid, 
          [state[action.list][action.containerCardinality][action.index][action.field]],
          action.merchandiseId,
          targetPGA
        )
        return state;
      }
      case `SAVE_REPEATED_FIELD_${targetPGA}_${pgaGuid}`: {
        let isArray =  Array.isArray(action.field);
        if(isArray){
          let arrayOfStuff =[];
          for(let onefield of action.field){
            arrayOfStuff.push(state[action.list][action.index][onefield])
          }
          savePGAItemField(pgaGuid, 
            arrayOfStuff,
            action.merchandiseId,
            targetPGA
          )
        } else {
          savePGAItemField(pgaGuid, 
            [state[action.list][action.index][action.field]],
            action.merchandiseId,
            targetPGA
          )
        }
        return state
      }
      case `REPLACE_REPEATED_SUB_GROUP_${targetPGA}_${totallyUniquePGAId}`: {
        let containerCardinality = action.containerCardinality;
        let listname = action.listname;
        if(!state[listname])return state;
        let mainlist = state[listname];
        if(!mainlist)return state;
        let newListOfItems = Array.isArray(action.newListOfItems) ? action.newListOfItems : [];
        const containerItems = Array.isArray(state[listname][containerCardinality])
          ? state[listname][containerCardinality]
          : [];
        const deletedGroup = containerItems.flatMap(item => Object.values(item || {}));
        const listToAdd = [];
        newListOfItems.forEach(itemGroup => {
          if(!itemGroup) return;
          Object.values(itemGroup).forEach(itemValue => {
            if(!itemValue.value)itemValue.value="";
            listToAdd.push(itemValue);
          });
        });
        if(!deletedGroup || !deletedGroup.length){
          savePGAItemField(pgaGuid, 
            listToAdd.concat(action.alsoAddThisSave||[]),
            action.merchandiseId,
            targetPGA
          )
        } else {
          deletePGAItems(
            pgaGuid,
            deletedGroup,
            action.merchandiseId,
            targetPGA
          ).then(response =>{
            savePGAItemField(pgaGuid, 
              listToAdd.concat(action.alsoAddThisSave||[]),
              action.merchandiseId,
              targetPGA
            )
          });
        }

        // Shallow copy the array - only the modified cardinality needs to be new
        let listCopy = state[listname] ? [...state[listname]] : [];
        listCopy[containerCardinality] = newListOfItems;
        
        return Object.assign({}, state, { [listname]: listCopy })

      }
      case `REMOVE_REPEATED_SUB_GROUP_${targetPGA}_${totallyUniquePGAId}`: {
        let cardinality = action.containerCardinality;
        let listname = action.list;
        if(!state[listname])return state;
        // Shallow copy to avoid mutating original state
        let mainlist = [...(state[listname] || [])];
        if(mainlist[cardinality]) {
          mainlist[cardinality] = [...mainlist[cardinality]];
        }
        if(!mainlist)return state;
        let deletedGroup = null;
        let removeByCardinality = (cardinalityXX) =>{
          deletedGroup = mainlist[cardinalityXX];
          mainlist[cardinalityXX] = null;
          if (deletedGroup) {
            const everyThingToDelete = deletedGroup.flatMap(group => Object.values(group || {}));
            deletePGAItems(
              pgaGuid,
              everyThingToDelete,
              action.merchandiseId,
              targetPGA
            )
          }
          
        }
        if(cardinality == 'all'){
          for(let iii=0;iii<mainlist.length;iii++ ){
            removeByCardinality(iii)
          }
        } if(action.payload == 'all'){
          removeByCardinality(cardinality)
        } else {
          deletedGroup = mainlist[cardinality][action.payload];
          mainlist[cardinality][action.payload]=null;
          if(deletedGroup){
            deletePGAItems(
              pgaGuid,
              Object.values(deletedGroup),
              action.merchandiseId,
              targetPGA
            )
          }

        }
        // for (let newindexoffsetbydeletion= 0; newindexoffsetbydeletion < mainlist.length; newindexoffsetbydeletion++) {
        //   if(!mainlist[newindexoffsetbydeletion])continue;
        //   for(var subkey of Object.keys(mainlist[newindexoffsetbydeletion])){
        //     mainlist[newindexoffsetbydeletion][subkey].key=mainlist[newindexoffsetbydeletion][subkey].key.split(".")[0]+
        //     "."+mainlist[newindexoffsetbydeletion][subkey].key.split(".")[1]+"."+
        //     (newindexoffsetbydeletion+1);

        //   }

        // }
        if(!deletedGroup)return state;
        
        // let groupKeys = Object.keys(deletedGroup)
        
      // let listToSave = state[listname];
      // Clone cardinality array items before mutating their properties
      if(mainlist[cardinality]) {
        mainlist[cardinality] = mainlist[cardinality].map(item => {
          if(!item) return item;
          // Clone the item object and all its nested property objects
          let clonedItem = {};
          for(let key of Object.keys(item)) {
            clonedItem[key] = item[key] ? {...item[key]} : item[key];
          }
          return clonedItem;
        });
      }
      let idxxxx = 1;
      (mainlist[cardinality]||[]).forEach(item =>{//relabel
        if(item){
          for(let onevarrr of Object.keys(item)){ 
            let thekey = item[onevarrr].key;
            if(!thekey)continue;//We hit a subgroup or something, ignore it
            const keyParts = thekey.split('.');
            const segmentOne = keyParts[0] || '';
            const segmentTwo = keyParts[1] || '';
            item[onevarrr].key = `${segmentOne}.${segmentTwo}.${idxxxx}`;
          }
          idxxxx++;
        }
      })
  
      let listToSave = mainlist;
        mainlist.forEach(item =>{
          if(item){
            savePGAItemField(pgaGuid, 
              Object.values(item.filter?item.filter(a=>a):item),
              action.merchandiseId,
              targetPGA
            )
          }
        } )
        
        for(let i=0;i<listToSave.length;i++){
          const listtoclean = listToSave[i];
          if(!listtoclean)continue;
          listToSave[i] = listtoclean.filter?listtoclean.filter((a)=>a):listtoclean;//strip nulls
        }
        return Object.assign({}, state, { [listname]: listToSave })

      }
      
      case `SAVE_REPEATED_SUB_SUB_FIELD_${targetPGA}_${totallyUniquePGAId}`: {
        if(!state[action.list])return state;
        if(!state[action.list][action.containerCardinality][action.innerContainerCardinality][action.index])return state;
        savePGAItemField(pgaGuid, 
          [state[action.list][action.containerCardinality][action.innerContainerCardinality][action.index][action.field]],
          action.merchandiseId,
          targetPGA
        )
        return state;
      }
      case `ADD_REPEATED_SUB_SUB_ITEM_${targetPGA}_${totallyUniquePGAId}`: {
        function getAllexistingindexes(boxforcurrentcardinality){
          let seen = [];
          for(var iii = 0; iii < boxforcurrentcardinality.length;iii++){
            if(boxforcurrentcardinality[iii]){
              let firstkey =find(boxforcurrentcardinality[iii],a=>a.key).key;
              seen[parseInt(firstkey.split(".")[3])-1]=true;
            }
          }
          return seen;
        }
        let cardinality = action.containerCardinality;
        let innerContainerCardinality = action.innerContainerCardinality;
        let listname = action.list;
        let newindex = 0;
        if(state[listname] && state[listname][cardinality]  && state[listname][cardinality][innerContainerCardinality]){
          let seen = getAllexistingindexes(state[listname][cardinality][innerContainerCardinality]);
          for(;newindex<seen.length;newindex++){
            if(!seen[newindex])break;
          }
        }
        let items = listMapper[listname](newindex)
        for(let itemkey of Object.keys(items)){
          items[itemkey].key = items[itemkey].key.split(".")[0]+"."+(cardinality+1)+"."+(innerContainerCardinality+1)+"."+(newindex+1);
          
        }
        let itemsToSave = []

        // Combine both loops - iterate once, update values and collect items
        Object.keys(items).forEach(itemKey => {
          if(action.initialValues_th[itemKey]){
            items[itemKey].value = action.initialValues_th[itemKey].value.value;
          }
          itemsToSave.push(items[itemKey]);
        });
        savePGAItemField(pgaGuid, itemsToSave, action.merchandiseId, targetPGA)
        let newItems = (state[listname] && state[listname][cardinality]  && state[listname][cardinality][innerContainerCardinality])
          ?state[listname][cardinality][innerContainerCardinality].slice()
          :[]   ;
        newItems.push(items)
        // Shallow copy the top-level array and the cardinality level
        let listToSave = state[listname] ? [...state[listname]] : [];
        if(listToSave[cardinality]) {
          listToSave[cardinality] = [...listToSave[cardinality]];
        } else {
          listToSave[cardinality] = [];
        }
        listToSave[cardinality][innerContainerCardinality] = newItems;
        return Object.assign({}, state, {[listname] : listToSave})

      
      }
      case `UPDATE_REPEATED_SUB_SUB_FIELD_${targetPGA}_${totallyUniquePGAId}`: {
        let list = state[action.list].slice()
        let cardinality = action.containerCardinality;;
        let innerContainerCardinality = action.innerContainerCardinality;
        if(!list[cardinality][innerContainerCardinality][action.index])return state;
        list[cardinality][innerContainerCardinality][action.index][action.field] = list[cardinality][innerContainerCardinality][action.index][action.field] || {};
        list[cardinality][innerContainerCardinality][action.index][action.field].value = action.payload
        
        return Object.assign({}, state, { [action.list]: list })
      }
      case `REMOVE_REPEATED_SUB_SUB_GROUP_${targetPGA}_${totallyUniquePGAId}`: {
        let cardinality = action.containerCardinality;
        let innerContainerCardinality = action.innerContainerCardinality;
        
        let listname = action.list;
        if(!state[listname])return state;
        // Shallow copy to avoid mutating original state
        let mainlist = [...(state[listname] || [])];
        if(!mainlist)return state;
        // Clone cardinality level array since we'll mutate it
        if(mainlist[cardinality]) {
          mainlist[cardinality] = [...mainlist[cardinality]];
        }
        let deletedGroup = null;
        const deleteMemberGroup = members => {
          if(!members || !members.length)return;
          const items = members.flatMap(member => Object.values(member || {}));
          if(items.length){
            deletePGAItems(
              pgaGuid,
              items,
              action.merchandiseId,
              targetPGA
            )
          }
        }
        if(action.innerContainerCardinality == 'all'){//you're deleting a node want to delete its grandchildren
          
          (mainlist[cardinality] || []).forEach((group, innerIdx) => {
            deletedGroup = group;
            mainlist[cardinality][innerIdx]=null;
            deleteMemberGroup(deletedGroup);
          })
        } 
        else if(action.payload == 'all'){//you're deleting a child and grandchildren
          if(mainlist[cardinality]){
            deletedGroup =  mainlist[cardinality][innerContainerCardinality];
            mainlist[cardinality][innerContainerCardinality]=null;
          }
          deleteMemberGroup(deletedGroup);
        } 
        else {
          deletedGroup = mainlist[cardinality][innerContainerCardinality][action.payload];
          mainlist[cardinality][innerContainerCardinality][action.payload]=null;
          if(!deletedGroup)return state;
          deletePGAItems(
            pgaGuid,
            Object.values(deletedGroup),
            action.merchandiseId,
            targetPGA
          )

        }
        if(!deletedGroup)return state;
        
        
        let listToSave = mainlist;
        mainlist.forEach(item =>{
          if(item){
            savePGAItemField(pgaGuid, 
              Object.values(item.filter(a=>a)),
              action.merchandiseId,
              targetPGA
            )
          }
        } )
        for(let i=0;i<listToSave.length;i++){
          const listtoclean = listToSave[i];
          if(!listtoclean)continue;
          for(let j=0;j<listtoclean.length;j++){
            const sublisttoclean = listtoclean[j];
            if(!sublisttoclean)continue;//list parent got deleted, what a shame
            console.log('sublisttoclean: ', listtoclean);
            listtoclean[j] = sublisttoclean.filter((a)=>a);//strip nulls
          }

        }
        console.log('2listToSave: ', listToSave);
        return Object.assign({}, state, { [listname]: listToSave })

      }
      case `REMOVE_REPEATED_GROUP_${targetPGA}_${totallyUniquePGAId}`: {
        window.rateLimitRemovalOfGuid = window.rateLimitRemovalOfGuid||{};
        if(window.rateLimitRemovalOfGuid[targetPGA+"xxx"+ totallyUniquePGAId] > Date.now())return state;
        window.rateLimitRemovalOfGuid[targetPGA+"xxx"+ totallyUniquePGAId] = Date.now()+1200;

        let list = [];
        let deletedGroup = [];
        if(action.payload==-1){ //-1 index is delete all
          for(let oneGroup of state[action.list]){
            for(let onekey of Object.keys(oneGroup||{})){
              deletedGroup[oneGroup[onekey].key]=oneGroup[onekey];
            }
          }
        } else {
          deletedGroup = state[action.list][action.payload]
          if (deletedGroup){
            let groupKeys = Object.keys(deletedGroup)
            for (let i = 0; i < groupKeys.length; i++) {
              deletedGroup[groupKeys[i]].key =
                state[action.list][state[action.list].length - 1][groupKeys[i]].key
            }
          }
          // Build new list with correct numbered keys
          list = state[action.list].slice(0, action.payload).concat(
            state[action.list].slice(action.payload + 1)
          )
          list = renumberPGAItems(list)
        }
        if(action.newListOfItems){
          list = action.newListOfItems;
        }
        let saveNewList = ()=>{
          // Use flatMap instead of concat in loop for better performance
          const allItems = list.flatMap(item => Object.values(item));
          const additionalItems = action.alsoAddThisSave ? Object.values(action.alsoAddThisSave) : [];
          const savedlist = allItems.concat(additionalItems);
          if(savedlist && savedlist.length){
            savePGAItemField(pgaGuid,
              savedlist,
              action.merchandiseId,
              targetPGA
            )
          }
        };
        if(deletedGroup){
          let deletionTime = deletePGAItems(
            pgaGuid,
            Object.values(deletedGroup||{}),
            action.merchandiseId,
            targetPGA
          )
          if(deletionTime){
            deletionTime.then(()=>{
              saveNewList();
            })
          } else {
            saveNewList();
          }
        } else {
          saveNewList();
        }
        return Object.assign({}, state, { [action.list]: list })
      }
      case `REMOVE_REPEATED_SECTION_${targetPGA}_${totallyUniquePGAId}`: {
        // Can only remove last section, not intermediate sections
        // Sections can contain repeated groups and repeated sub groups
        let finalState = {}
        Object.assign(finalState, state)
        if(action.payload < 0){
          return state
        }
        else{
          let itemsToBeDeleted
          let savedlist = []
          let deletedGroup = []
          let invalidList = false
          action.listArray.forEach(repeatedList => {
            const repeatedState = state[repeatedList] || []
            const trimmedList = repeatedState.slice(0, action.payload)
            itemsToBeDeleted = repeatedState[action.payload]
            if(typeof itemsToBeDeleted === 'undefined'){
              invalidList = true
              return
            }
            if(itemsToBeDeleted && !Array.isArray(itemsToBeDeleted)){
              deletedGroup = deletedGroup.concat(Object.values(itemsToBeDeleted))
              // Use flatMap instead of concat in loop for better performance
              const existingItems = trimmedList
                .filter(existingGroup => existingGroup)
                .flatMap(existingGroup => Object.values(existingGroup));
              savedlist = savedlist.concat(existingItems);
            }
            else if(Array.isArray(itemsToBeDeleted)){
              // Use flatMap instead of concat in loop for better performance
              const subItems = itemsToBeDeleted.flatMap(subItemsToBeDeleted => 
                Object.values(subItemsToBeDeleted || {})
              );
              deletedGroup = deletedGroup.concat(subItems);
              // Use flatMap for nested structure
              const existingItems = trimmedList
                .filter(existingGroup => existingGroup)
                .flatMap(existingGroup => 
                  existingGroup
                    .filter(existingSubGroup => existingSubGroup)
                    .flatMap(existingSubGroup => Object.values(existingSubGroup))
                );
              savedlist = savedlist.concat(existingItems);
            }
            Object.assign(finalState, finalState, {[repeatedList]: trimmedList})
          })
          if(invalidList){
            return state
          }
          if(deletedGroup.length > 0){
            deletePGAItems(
              pgaGuid,
              deletedGroup,
              action.merchandiseId,
              targetPGA
            )
          }
          if(savedlist.length > 0){
            savePGAItemField(pgaGuid, 
              savedlist,
              action.merchandiseId,
              targetPGA
            )
          }
        }
        return finalState
      }
      case `TOGGLE_${targetPGA}_${totallyUniquePGAId}`: {
        if (action.payload === null) {
          return { activeFDAFOOMerchandiseId: null, loading: true,
            pgaGuid: action.pgaGuid, }
        } else {
          return Object.assign({}, state, {
            activeFDAFOOMerchandiseId: action.payload,
            pgaGuid: action.pgaGuid,
          })
        }
      }
      // CONTAINERS
      case `ADD_CONTAINER_${targetPGA}_${totallyUniquePGAId}`: {
        let containers = state.containers.slice()
        let newContainer = {
          key: 'containerNum.' + (state.containers.length + 1),
          dataType: 'STRING',
          isOptional: 'N',
          uiLabel: 'Container Number',
          uiInputType: 'DISPLAY',
          uiLabelDesc: 'Container Number',
          PGAId: 'containerNum',
          isRepeated: 'Y',
          lengthClass: '20AN'
        }
        containers.push(newContainer)
        return Object.assign({}, state, { containers })
      }
      case `UPDATE_CONTAINER_${targetPGA}_${totallyUniquePGAId}`: {
        let newContainer = state.containers.slice()
        newContainer[action.index].value = action.payload
        return Object.assign({}, state, { containers: newContainer })
      }
      case `SAVE_CONTAINER_${targetPGA}_${totallyUniquePGAId}`: {
        savePGAItemField(pgaGuid, 
          [state.containers[action.payload]],
          action.merchandiseId,
          targetPGA
        )
        return state
      }
      case `REMOVE_CONTAINER_${targetPGA}_${totallyUniquePGAId}`: {
        // Get Container to be deleted
        let deletedContainer = state.containers[action.payload]
        deletedContainer.key = state.containers[state.containers.length - 1].key
        // Build new contianer list with correct numbered keys
        let containers = state.containers
          .slice(0, action.payload)
          .concat(state.containers.slice(action.payload + 1))
        containers = renumberLaceyActContainers(containers)
        // Delete Container
        deletePGAItems(
          pgaGuid, [deletedContainer], action.merchandiseId, targetPGA)
        // Save new containers
        savePGAItemField(pgaGuid, containers, action.merchandiseId, targetPGA)
        return Object.assign({}, state, { containers })
      }
      default:
        return state
    }
  }
}
